import { builtEnvironment, getBaseUrl } from '.';

export function getIntroIntakeFormApiEndPoint(
  advisorId: string,
  shouldSendClientEmail: boolean | null,
  surveyId?: string,
  customReferralSourceId?: string,
  redtailContactId?: string,
  wealthboxContactId?: string,
): string {
  const baseUrl = getBaseUrl();
  const advisorIdWithQueryParams = `${encodeURIComponent(advisorId)}?should_send_client_email=${shouldSendClientEmail ? encodeURIComponent(shouldSendClientEmail) : 'false'}${surveyId ? `&survey_id=${encodeURIComponent(surveyId)}` : ''}${customReferralSourceId ? `&custom_referral_source_id=${encodeURIComponent(customReferralSourceId)}` : ''}${redtailContactId ? `&redtail_contact_id=${encodeURIComponent(redtailContactId)}` : ''}${wealthboxContactId ? `&wealthbox_contact_id=${encodeURIComponent(wealthboxContactId)}` : ''}`;

  return builtEnvironment === 'prod'
    ? `${baseUrl}/prod/api/public/intro-intake-form/${advisorIdWithQueryParams}`
    : `${baseUrl}/dev/api/public/intro-intake-form/${advisorIdWithQueryParams}`;
}
